/* bsp-size-guard (03.10.2026, alisveris simulasyonu bulgusu)
 * Varyant secimi temada otomatik ilk numara (36) ile gelir; musteri secmeden sepete atarsa yanlis numara/iade riski.
 * Tema ayarini (select_first_variant) degistirmeden: URL'de ?variant= yoksa Size dropdown'i "Select your size" gosterir,
 * musteri bir numara secene kadar Add to cart / Buy it now engellenir, liste acilir. Ayrica Size etiketinin yanina beden rehberi linki.
 */
(function () {
  var L = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  var T = {
    en: ['Select your size', 'Please select your size first', 'Size guide'],
    tr: ['Numaranızı seçin', 'Lütfen önce numaranızı seçin', 'Beden rehberi'],
    ar: ['اختر مقاسك', 'يرجى اختيار المقاس أولاً', 'دليل المقاسات'],
    de: ['Größe wählen', 'Bitte zuerst eine Größe wählen', 'Größentabelle'],
    fr: ['Choisissez votre pointure', 'Veuillez d’abord choisir votre pointure', 'Guide des tailles'],
    es: ['Elige tu talla', 'Primero elige tu talla', 'Guía de tallas'],
    it: ['Scegli la tua taglia', 'Scegli prima la tua taglia', 'Guida alle taglie'],
    nl: ['Kies je maat', 'Kies eerst je maat', 'Maattabel'],
    pl: ['Wybierz rozmiar', 'Najpierw wybierz rozmiar', 'Tabela rozmiarów'],
    pt: ['Escolha o seu tamanho', 'Escolha primeiro o seu tamanho', 'Guia de tamanhos'],
    ru: ['Выберите размер', 'Сначала выберите размер', 'Таблица размеров'],
    sv: ['Välj storlek', 'Välj storlek först', 'Storleksguide'],
    ja: ['サイズを選択', '先にサイズを選択してください', 'サイズガイド']
  };
  var t = T[L] || T.en;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var chosen = window.__bspSizeChosen = window.__bspSizeChosen || {};
  var hasVariantParam = /[?&]variant=/.test(location.search);

  function sizeSelector(picker) {
    var s = picker.querySelector('.option-selector[data-option="Size" i], .option-selector[data-option="Numara" i]');
    return s || picker.querySelector('.option-selector[data-selector-type="dropdown"]');
  }
  function key(el) { var p = el.closest('variant-picker'); return p ? (p.getAttribute('data-section-id') || 'x') : 'x'; }
  function formOf(el) {
    var sec = el.closest('[id^="shopify-section"], .quickbuy-content, .quickbuy-container') || document;
    return sec.querySelector('form[action*="/cart/add"]');
  }
  function init(picker) {
    if (picker.dataset.bspGuard) return;
    picker.dataset.bspGuard = '1';
    var sel = sizeSelector(picker); if (!sel) return;
    // beden rehberi linki (yoksa)
    var lab = sel.querySelector('label.label, legend.label');
    if (lab && !sel.querySelector('.bsp-size-guide')) {
      var a = document.createElement('a');
      a.href = root + 'pages/sizing'; a.className = 'bsp-size-guide'; a.textContent = t[2];
      lab.insertAdjacentElement('afterend', a);
      sel.classList.add('bsp-has-guide');
    }
    var k = key(picker);
    if (hasVariantParam || chosen[k]) return;
    var span = sel.querySelector('.custom-select__btn > span');
    if (span) { span.dataset.bspOrig = span.textContent; span.textContent = t[0]; }
    sel.classList.add('bsp-size-unset');
    picker.classList.add('bsp-size-unset-picker');
  }
  function markChosen(el) {
    var picker = el.closest('variant-picker'); if (!picker) return;
    chosen[key(picker)] = true;
    picker.classList.remove('bsp-size-unset-picker');
    var sel = sizeSelector(picker); if (sel) sel.classList.remove('bsp-size-unset');
    var span = sel && sel.querySelector('.custom-select__btn > span');
    var v = el.getAttribute && el.getAttribute('data-value');
    if (span && v) span.textContent = v; else if (span && span.textContent === t[0] && span.dataset.bspOrig) span.textContent = span.dataset.bspOrig;
    var f = formOf(picker); var err = f && f.parentElement && f.parentElement.querySelector('.bsp-size-err'); if (err) err.remove();
  }
  function scan() { document.querySelectorAll('variant-picker').forEach(init); }

  // numara secimi
  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('variant-picker .custom-select__option, variant-picker .opt-label');
    if (opt) markChosen(opt);
  }, true);
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('variant-picker custom-select')) {
      setTimeout(function () { markChosen(e.target); }, 0);
    }
  }, true);

  // sepete ekle / hemen al engeli
  function guard(e) {
    var btn = e.target.closest && e.target.closest('button.add-to-cart, .shopify-payment-button, .shopify-payment-button__button');
    if (!btn) return;
    var sec = btn.closest('[id^="shopify-section"], .quickbuy-content, .quickbuy-container') || document;
    var picker = sec.querySelector('variant-picker.bsp-size-unset-picker');
    if (!picker) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var sel = sizeSelector(picker);
    if (sel) {
      sel.classList.remove('bsp-shake'); void sel.offsetWidth; sel.classList.add('bsp-shake');
      if (!sel.querySelector('.bsp-size-err')) {
        var m = document.createElement('p'); m.className = 'bsp-size-err'; m.setAttribute('role', 'alert'); m.textContent = t[1];
        sel.appendChild(m);
      }
      var b = sel.querySelector('.custom-select__btn');
      sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (b && b.getAttribute('aria-expanded') !== 'true') setTimeout(function () { b.click(); }, 350);
    }
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var sec = f.closest('[id^="shopify-section"], .quickbuy-content, .quickbuy-container') || document;
    if (sec.querySelector('variant-picker.bsp-size-unset-picker')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // 03.10 perf: global MutationObserver kaldirildi (Loox/Clarity DOM mutasyonlariyla ~600 ms bootup). Sadece:
  // sayfa hazir + load, ve quick-buy acildiginda kisa yoklama.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('.quickbuy-toggle, .js-quickbuy, [data-quickbuy], .bespoky-quick-add'))) return;
    var n = 0, iv = setInterval(function () { scan(); if (++n > 20) clearInterval(iv); }, 200);
  }, true);
  document.addEventListener('on:variant:change', scan);
})();
